'use client';

import viewContentPixelEvent, {
    type ViewContentPixelEvent,
} from '@app/lib/events/view-content.pixel';
import { useEffect } from 'react';

const MetaPixelTracker = ({ product, currencyCode }) => {
    useEffect(() => {
        const event: ViewContentPixelEvent = {
            content_ids: [product.id],
            content_type: 'product',
            content_category: 'Apparel & Accessories',
            content_name: product.title,
            value: product.price,
            currency: currencyCode,
        };
        viewContentPixelEvent(event);
    }, [product, currencyCode]);

    return null;
};

export default MetaPixelTracker;
